import React from "react";
import { Globe, Phone, Mail, BookOpen } from "lucide-react";
import { Badge } from "./Primitives";

function initials(name) {
  return name
    .split(/\s+/)
    .filter((w) => /^[A-Za-z]/.test(w))
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");
}

export default function SponsorCard({ sponsor }) {
  return (
    <div className="card-bcs p-6 flex flex-col" data-testid={`sponsor-card-${sponsor.id}`}>
      <div className="flex items-start justify-between">
        {sponsor.logo_url ? (
          <img
            src={sponsor.logo_url}
            alt={sponsor.name}
            className="h-14 w-14 rounded-lg object-contain bg-cream-alt p-1.5 border border-gray-100"
          />
        ) : (
          <div className="h-14 w-14 rounded-lg bg-gold-50 border border-gold-light/40 flex items-center justify-center font-serif text-lg font-semibold text-gold-dark">
            {initials(sponsor.name)}
          </div>
        )}
        {sponsor.souvenir_page && (
          <span className="inline-flex items-center gap-1.5 text-[11px] font-medium text-maroon bg-maroon-50 rounded-full px-2.5 py-1">
            <BookOpen size={12} /> Souvenir · p.{sponsor.souvenir_page}
          </span>
        )}
      </div>

      <div className="mt-4">
        <Badge tone="gold">{sponsor.tier}</Badge>
      </div>

      <h3 className="mt-3 font-serif text-xl font-semibold text-ink leading-snug">{sponsor.name}</h3>
      {sponsor.business_name && (
        <p className="text-sm text-ink-muted mt-0.5">{sponsor.business_name}</p>
      )}
      <p className="mt-3 text-sm text-ink-soft leading-relaxed flex-1">{sponsor.description}</p>

      <div className="mt-5 pt-4 border-t border-gray-100 flex items-center gap-3 text-ink-muted">
        {sponsor.website && (
          <a
            href={sponsor.website}
            target="_blank"
            rel="noreferrer"
            className="hover:text-maroon transition-colors"
            aria-label="Website"
            data-testid={`sponsor-website-${sponsor.id}`}
          >
            <Globe size={17} />
          </a>
        )}
        {sponsor.phone && (
          <a href={`tel:${sponsor.phone}`} className="hover:text-maroon transition-colors" aria-label="Call">
            <Phone size={17} />
          </a>
        )}
        {sponsor.email && (
          <a href={`mailto:${sponsor.email}`} className="hover:text-maroon transition-colors" aria-label="Email">
            <Mail size={17} />
          </a>
        )}
        <span className="ml-auto text-[11px] uppercase tracking-wider font-medium text-ink-muted">
          {sponsor.category}
        </span>
      </div>
    </div>
  );
}
